export default "__VITE_PUBLIC_ASSET__44163f6d__"